import React from "react";
import BottomBarNavigationItem from "./BottomBarNavigationItem";
import { FormattedMessage } from "react-intl";
import { LocalizationMessages } from "../../../localization/messages";
import { AppHelpers } from "../../../hooks/useWidgetInitialization/helpers";
import { NavigationUtils, PageContextUtils } from "../../../utils";
import { UISelectors } from "../../../redux/selectors";
import { useSelector } from "react-redux";

const InPlayBottomBarNavigationItem = () => {
  const links = useSelector(UISelectors.links);
  const { contentLangId } = PageContextUtils.getLocalizationData();

  const onInPlayClick = () => {
    AppHelpers.toggleBetslipVisibility(false);
    const inPlayURL = getInPlayURL();
    NavigationUtils.navigateTo(inPlayURL);
  };

  const getInPlayURL = () => {
    if (typeof links.liveNow === "string") {
      return links.liveNow;
    }
    if (typeof links.liveNow === "object") {
      return links.liveNow[contentLangId] || links.liveNow.en;
    }
  };

  return (
    <BottomBarNavigationItem
      onClick={onInPlayClick}
      iconColor={"white"}
      iconLabel={"inplay"}
      dataTestId={"bottom-navigation-inplay"}
      googleAnalyticsLabel={"inplay"}
    >
      <FormattedMessage {...LocalizationMessages.bottomNavigationInPlay} />
    </BottomBarNavigationItem>
  );
};

export default React.memo(InPlayBottomBarNavigationItem);

InPlayBottomBarNavigationItem.propTypes = {};
